import { Checkbox, DataHeader, DataSource, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBonusCodes extends Layout {
    checkboxDed401k: Checkbox;
    checkboxDedPrevBalance: Checkbox;
    checkboxIsActive: Checkbox;
    checkboxPrintCheck: Checkbox;
    dataheaderBonusCode: DataHeader;
    panelGeneral: Panel;
    sourceBonusCodeDtl: DataSource;
    sourceBonusCodeHdr: DataSource;
    tablePayAdjustmentCodes: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
